import moment from 'moment';
import { Rental } from '../../../services/models/rental';
import { getEquipmentLockLabel, getRentalStatusInfo } from '../utils/rentalUtils';

interface RentalTooltipProps {
  rental: Rental;
  x: number;
  y: number;
}

const RentalTooltip: React.FC<RentalTooltipProps> = ({ rental, x, y }) => {
  const status = getRentalStatusInfo(rental.rentalStatus);
  const start = moment.utc(rental.startDateUTC).local();
  const end = moment.utc(rental.endDateUTC).local();

  return (
    <div
      className="absolute z-20 pointer-events-none"
      style={{ left: x, top: y, transform: 'translate(-50%, calc(-100% - 8px))' }}
    >
      <div className="flex flex-col w-48 rounded-md py-2.5 px-3.5 gap-1 bg-neutral shadow-lg">
        <div className="flex items-center justify-between gap-1.5">
          <span className="typo-small text-white font-medium leading-4 truncate">
            {rental.user.firstName} {rental.user.lastName}
          </span>
          <span className="typo-caption leading-3.5 text-white/70 whitespace-nowrap">
            {status.label}
          </span>
        </div>
        {rental.equipments?.length ? (
          <div className="flex flex-col gap-0.5">
            {rental.equipments.map((equipment) => {
              const lockLabel = getEquipmentLockLabel(equipment);
              return (
                <span key={equipment.id} className="typo-caption text-white/50 leading-3.5">
                  {lockLabel && (
                    <span className="text-white/90 font-semibold">{lockLabel}</span>
                  )}
                  {lockLabel && ' · '}
                  {equipment.model}
                </span>
              );
            })}
          </div>
        ) : (
          <span className="typo-caption text-white/50 leading-3.5">—</span>
        )}
        <span className="typo-caption text-white leading-3.5">
          {start.format('DD/MM HH:mm')} → {end.format('DD/MM HH:mm')}
        </span>
      </div>
    </div>
  );
};

export default RentalTooltip;
